module.exports = __webpack_public_path__ + "static/media/RKBrowser6w1442@2x.371e00b4.webp";